// extracted by mini-css-extract-plugin
export default {"title":"_5YA7I","skeleton-progress":"QUD0d"};